import { I18n } from 'aws-amplify';

export const i18n: (key: string) => string = (key: string) => {
  return I18n.get(key) as string;
};
